/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Pace_Est_10kInputs */

const en_ui_pace_est_10k = /** @type {(inputs: Ui_Pace_Est_10kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10K`)
};

const de_ui_pace_est_10k = /** @type {(inputs: Ui_Pace_Est_10kInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 km`)
};

/**
* | output |
* | --- |
* | "10K" |
*
* @param {Ui_Pace_Est_10kInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_pace_est_10k = /** @type {((inputs?: Ui_Pace_Est_10kInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Pace_Est_10kInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_pace_est_10k(inputs)
	return de_ui_pace_est_10k(inputs)
});